export default function WhyDifficult() {
  return (
    <section className="py-24 bg-[#8FAE9A]/15">
      <div className="max-w-[1100px] mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center gap-12">
          <div className="w-full md:flex-1 order-2 md:order-1">
            <img
              src="https://public.readdy.ai/ai/img_res/7ea4d4743979048572fe1f14ea74835d.jpg"
              alt="悩んでいる様子"
              className="w-full h-auto rounded-2xl shadow-[0_6px_18px_rgba(0,0,0,0.08)]"
            />
          </div>
          <div className="w-full md:flex-1 order-1 md:order-2">
            <h2 className="text-3xl font-bold text-[#7A5A44] mb-6 leading-relaxed">
              なぜ一人では<br />判断できないのか
            </h2>
            <p className="text-[#5A4033] text-lg leading-[1.8] mb-6">
              住宅会社は建物の視点、<br />
              不動産屋は土地の視点、<br />
              金融機関はお金の視点。
            </p>
            <p className="text-[#5A4033] text-lg leading-[1.8] mb-6">
              どれも正しいけれど、<br />
              あなたの状況全体を見てくれる人はいません。
            </p>
            <p className="text-[#7A5A44] text-base leading-[1.8] font-medium">
              だから、情報が増えるほど判断できなくなるのです。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}